export default {
  retrieveSubDriverList (state, payload) {
    state.subDriverList = payload.subDriverList

  },
  addSubDriverToList (state, payload) {
    state.subDriverList = [].concat(payload.subDriver)
  },
  getSubDriverInfo (state, payload) {
    state.subDriverInfo = payload.subDriverInfo
    if (!("password" in state.subDriverInfo)) {
      state.subDriverInfo["password"] = ""
    }
  },
  deleteSubDriver (state, payload) {
    state.subDriverList.splice(payload.subDriverInfo.index, 1);
  },
  updateState (state, payload) {
    state.currentFilter = payload.filter ? Object.assign({}, payload.filter) : null
    state.currentSort = payload.sort ? Object.assign({}, payload.sort) : null
    state.currentPage = payload.page ? payload.page : null
  }
}
